import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import type { GeneralResp } from '@/models/GeneralResp';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 重新發送 OTP 簡訊回應
 */
export interface ISendSmsOtpResponse extends GeneralResp {
    /** 手機號碼 */
    mobile?: string;
    /** 狀態碼 */
    code?: number;
    /** 文字訊息 */
    letter?: string;
    /** 是否處於等候再次發送區間 */
    isInWaitToSendAgain?: boolean;
    /** 單日發送次數上限 */
    dayLimit?: number;
    /** 當日發送次數 */
    times?: number;
}

/**
 * 登入 - 重新發送 OTP 簡訊驗證碼 API
 *
 * @description 重新發送 OTP 簡訊驗證碼（從 Session 取得之前的手機號碼）
 * @returns Promise<ISendSmsOtpResponse>
 */
const SendSmsOtp = (): Promise<ISendSmsOtpResponse> => {
    const url = RouteUrlList.API_SendSmsOtp.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return ApiClient.post(url, {}, config).then((res: AxiosResponse<ISendSmsOtpResponse>) => {
        return res.data;
    });
};

export default SendSmsOtp;
